// extracted by mini-css-extract-plugin
export default {"zoomModal":"J2-z"};